export default __webpack_public_path__ + "static/media/product-image-11.a0bd3ed5.png";